import { MexicoFlag, USAFlag } from "../../components/icons";

const propsColumns = () => {
	return { scroll: { x: "100%", y: null } };
};

const columnsType = (editAction, deleteAction) => {
	return [
		{
			title: "Equivalencia de horas",
			dataIndex: "name",
			key: "name",
			render: (text) => {
				let icon;
				if (text.includes("MX")) {
					icon = <MexicoFlag />;
				}
				if (text.includes("Dll")) {
					icon = <USAFlag />;
				}

				return (
					<span className="flex justify-start items-center gap-2">
						{text} {icon}
					</span>
				);
			},
			sorter: (a, b) => {
				if (a.name < b.name) {
					return -1;
				}
				if (a.name > b.name) {
					return 1;
				}
				return 0;
			},
		},
		{
			title: "Horas",
			dataIndex: "hrs",
			key: "hrs",
			render: (text) => <span>{text}</span>,
		},
	];
};

export const columnsEquivalencySimulation = (editAction, deleteAction) => {
	const columns = columnsType(editAction, deleteAction);
	const props = propsColumns();
	return {
		columns,
		props,
	};
};
